/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_Na_Run_WaitInputs */

const en_inbox_na_run_wait = /** @type {(inputs: Inbox_Na_Run_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Building…`)
};

const id_inbox_na_run_wait = /** @type {(inputs: Inbox_Na_Run_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedang dibangun…`)
};

/**
* | output |
* | --- |
* | "Building…" |
*
* @param {Inbox_Na_Run_WaitInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_na_run_wait = /** @type {((inputs?: Inbox_Na_Run_WaitInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Na_Run_WaitInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_na_run_wait(inputs)
	return en_inbox_na_run_wait(inputs)
});